<template>
	<div class="record">
		<h1>记录线</h1>
		<div class="record-boxes">
			<div class="boxes">
				<div class="box" v-for="item in list" :key="item.id">
					<!--<p class="icon"></p>-->
					<h2>{{item.title}}</h2>
					<p class="time">{{item.time}}</p>
					{{item.content}}
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
export default {
	data(){
		return {
			list:[
				{id:10,title:'反馈完善',time:'2024-01-15',content:'还有部分小问题，不断完善中...'},
				{id:9,title:'推出试用',time:'2023-12-22',content:'在各位厅主、歌手的帮助下顺利进入试用阶段'},
				{id:8,title:'继续完善',time:'2023-12-19',content:'优化了细节的展示，进入测试'},
				{id:7,title:'基本功能',time:'2023-12-15',content:'完成开发基本的扣排、识别、定时发送跟排功能'},
				{id:6,title:'开发扣排器',time:'2023-11-30',content:'收集资料，准备采用微信3.7开发机器人各种功能'},
				{id:5,title:'深入交流',time:'2023-11-23',content:'在与女模深入交流后，决定启动项目开发'},
				{id:4,title:'再次出发',time:'2023-11-20',content:'凭借自己的技能优势，结合自己身处的大环境，准备做一款惠人惠己的多功能产品，解决厅主、歌手的烦劳'},
				{id:3,title:'扣排乱象',time:'2023-11-15',content:'机器人太多了，发麦序、扣排、打卡、娱乐机器人一大堆，有些贵还服务差功能不好用'},
				{id:2,title:'热爱语音',time:'2023-11-07',content:'没了工作，只想躺平，上线唱唱歌，与女模互诉倾心'},
				{id:1,title:'创建幻音阁',time:'2023-10-30',content:'月底被裁员，偶然间接触了语音平台，自己也喜欢唱歌'},
			]
		}
	}
	
}
</script>

<style lang="scss" scoped>
	
	@import url("https://fonts.googleapis.com/css?family=Lato:200,300,400,400i,700");
	@import url("https://fonts.googleapis.com/css?family=Merriweather:200,400,400i,700");
	
	.record {
		background-color: #181818;
		background-color: rgba(16 18 27 / 10%);
		color: #d8d8d8;
		font-family: Lato, sans-serif;
		padding: 20px 40px;
		width: 100%;
		overflow: auto;
		
		h1{
			font-size: 2.5em;
			text-transform: uppercase;
			letter-spacing: 10px;
			text-align: center;
			font-family: Lora, serif;
			font-weight: 200;
			
			&::before {
				content: '─';
				margin-right: 0.6em;
				color: #686868;
				color: #d8d8d8;
			}
			&::after {
				content: '─';
				margin-left: 0.6em;
				color: #686868;
				color: #d8d8d8;
			}
		}
		
		.record-boxes{
			width: 100%;
			
			.boxes {
				margin-top: 50px;
				display: flex;
				flex-wrap: wrap;
				margin-right: -30px;
				
				
				.box {
					width: calc(33.333333% - 30px);
					margin-right: 30px;
					font-size: 1em;
					line-height: 1.5em;
					font-weight: 200;
					padding: 0 1vw 1vw;
					margin-bottom: 40px;
					border-right: 2px;
					border-left: 0;
					border-style: solid;
					//text-align: left;
					//border-image: linear-gradient(to bottom, #ccc, #555 66%, #181818) 1 100%;
					//border-image: linear-gradient(to bottom, #181818, #eee, #181818) 1 100%;
					border-image: linear-gradient(to bottom, #10121B19, white, #10121B19) 1 100%;
					
					
					h2 {
						font-size: 1.3em;
						//text-transform: uppercase;
						letter-spacing: 4px;
						font-weight: 200;
						line-height: 0.5em;
						color: #f2f2f2;
					}
					.time {
						font-style: italic;
						color: #9f9f9f;
						margin-bottom: 0.5em;
						letter-spacing: 1px;
						font-family: Lora, serif;
						//background-color: red;
					}
					
					
					&:hover{
						transform: scale(1.02);
						//background-color: rgba(16 18 27 / 20%);
					}
					
					@media screen and (min-width: 1000px){
						
						// 只选取三的倍数的元素
						&:nth-child(3n){
							border-right: 0;
						}
					}
					
					@media screen and (max-width: 1000px) {
						width: calc(50% - 30px);
						
						&:nth-child(2n){
							border-right: 0;
						}
						
					}
					@media screen and (max-width: 565px) {
						width: calc(100% - 30px);
						padding: 0 5vw 1vw;
						border-right: 0;
						border-left: 2px;
						border-style: solid;
						border-image: linear-gradient(to bottom, #181818, #eee, #181818) 1 100%;
						
					}
				}
				
				
			}
		}
	}
	
	
</style>